import axios from '@/libs/api.request'

export const getPagedContacts = (page, limit) => {
  return axios.request({
    url: `contacts`,
    method: 'get',
    params: {
      page,
      limit
    }
  })
}

export const queryContacts = (keyword, tags, page, size) => {
  if (tags !== null) {
    return axios.request({
      url: `search/contact`,
      method: 'get',
      params: {
        q: keyword,
        filters: {
          tags
        },
        page,
        size
      }
    })
  } else {
    return axios.request({
      url: `search/contact`,
      method: 'get',
      params: {
        q: keyword,
        page,
        size
      }
    })
  }
}

export const addContact = (data) => {
  return axios.request({
    url: `contacts/create`,
    method: 'post',
    data
  })
}

export const getSingleContact = (id) => {
  return axios.request({
    url: `contacts/${id}`,
    method: 'get'
  })
}

export const updateSingleContact = (id, data) => {
  return axios.request({
    url: `contacts/${id}`,
    method: 'put',
    data
  })
}

export const deleteSingleContact = (id) => {
  return axios.request({
    url: `contacts/${id}`,
    method: 'delete'
  })
}

export const attachDetachCompany = (id, data) => {
  return axios.request({
    url: `contacts/${id}/update-company`,
    method: 'post',
    data
  })
}
export const loadHubspotContacts = (id, data) => {
  return axios.request({
    url: `contacts/load-hubspot-contact`,
    method: 'get'
  })
}
export const syncHsContactsToPangu = (data) => {
  return axios.request({
    url: `contacts/sync-hubspot-contacts`,
    method: 'post',
    data
  })
}
export const searchHubspot = (data) => {
  return axios.request({
    url: `contacts/search-hubspot`,
    method: 'get',
    params: data
  })
}
